import React from 'react';
import { ErscheinungsbildForm, ErscheinungsbildHeader } from '../components';
import { useLoaderData } from 'react-router-dom';
import customFetch from '../utils/customFetch';
import LinkNavigation from '../components/links/LinkNavigation';
import { useQuery } from '@tanstack/react-query';
import { buildCloudinaryUrl } from '../utils/buildCloudinaryUrl';

const erscheinungsbildQuery = {
  queryKey: ['erscheinungsbild'],
  queryFn: async () => {
    const data = await customFetch.get('/links/settings/erscheinungsbild');
    return data;
  },
};

export const loader = (queryClient) => async () => {
  const { data } = await queryClient.ensureQueryData(erscheinungsbildQuery);
  return data;
};

const Erscheinungsbild = () => {
  const { linkSettings } = useQuery(erscheinungsbildQuery).data.data;
  return (
    <>
      <LinkNavigation />
      <ErscheinungsbildHeader />
      <ErscheinungsbildForm {...linkSettings} />
    </>
  );
};

export default Erscheinungsbild;
